module.exports = __webpack_public_path__ + "static/media/Inter-Regular.52355593.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-Regular.ttf
// module id = 361
// module chunks = 17